// utils/auth.js
/**
 * 认证工具类
 * @author LWX
 * @date 2026-03-23
 * 修改：从 Cookie 改为 localStorage，配合 Redis token 验证
 */

const TokenKey = 'ShareWin-Token'
const TokenTimeKey = 'ShareWin-Token-Time'  // 新增：token存储时间
const UserInfoKey = 'ShareWin-User'

/**
 * 获取 token
 */
export function getToken() {
    return localStorage.getItem(TokenKey)
}

/**
 * 设置 token
 */
export function setToken(token) {
    localStorage.setItem(TokenKey, token)
    localStorage.setItem(TokenTimeKey, Date.now().toString())
}

/**
 * 移除 token
 */
export function removeToken() {
    localStorage.removeItem(TokenKey)
    localStorage.removeItem(TokenTimeKey)
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
    const userInfoStr = localStorage.getItem(UserInfoKey)
    if (userInfoStr) {
        try {
            return JSON.parse(userInfoStr)
        } catch (e) {
            return null
        }
    }
    return null
}

/**
 * 设置用户信息
 */
export function setUserInfo(userInfo) {
    if (userInfo) {
        localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
    }
}

/**
 * 移除用户信息
 */
export function removeUserInfo() {
    localStorage.removeItem(UserInfoKey)
}

/**
 * 清除所有认证信息
 */
export function clearAuth() {
    removeToken()
    removeUserInfo()
}

/**
 * 获取 token 存储时间（用于判断是否需要刷新）
 */
export function getTokenTime() {
    const timeStr = localStorage.getItem(TokenTimeKey)
    if (timeStr) {
        return parseInt(timeStr)
    }
    return null
}

/**
 * 检查 token 是否需要刷新（可选功能）
 * @param {number} threshold 阈值（毫秒），默认 30 分钟
 */
export function shouldRefreshToken(threshold = 30 * 60 * 1000) {
    const tokenTime = getTokenTime()
    if (!tokenTime) return true

    const now = Date.now()
    // 如果 token 存储时间超过阈值，建议刷新
    return (now - tokenTime) > threshold
}